<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            :current-component="component"
            @set-parent-prop="propSetFromChild($event)"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <component
                :is="component"
                :organization="organization"
                :title="compToProp(component, true).title"
                :fields="compToProp(component, true).fields"
                :sourceType="compToProp(component, true).source_type"
                :invoices="invoices"
                :patients="patients"
                :therapists="therapists"
                :pagination="pagination"
                :loading="loading"
                :places-of-service="placesOfService"
                @fetch-invoices="fetchInvoices()"
                @fetch-page="fetchPage($event)"
                @local-update="localUpdateInvoice($event)"
                @update-invoice="updateInvoice($event)"
                @recover-invoices="moveInvoicesToFunding($event)"
                @move-invoices="moveInvoicesToPaid($event)"
            >
                <div class="my-3 px-3 form-group row">
                    <input
                        type="text"
                        class="form-control form-control-sm col-8 col-sm-4"
                        v-model="q"
                        placeholder="Search by Patient First or Last Name"
                        @keyup.enter="fetchInvoices()"
                    />
                    <button
                        class="col-2 btn btn-sm btn-primary text-white text-uppercase ml-3"
                        @click="fetchInvoices()"
                    >
                        Search
                    </button>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import { sideMenuItems } from "../plugins/sideMenuItems";
import FundingSourcesSchools from "./funding-sources/FundingSourcesSchools";
import FundingSourcesRegionalCenters from "./funding-sources/FundingSourcesRegionalCenters";
import FundingSourcesEasterseals from "./funding-sources/FundingSourcesEasterseals";
import FundingSourcesInsuranceProviders from "./funding-sources/FundingSourcesInsuranceProviders";
import FundingSourcesPrivatePay from "./funding-sources/FundingSourcesPrivatePay";
import FundingSourcesPaid from "./funding-sources/FundingSourcesPaid";
import { helpers } from "../plugins/helpers";
import ModalComponent from "./ui/ModalComponent";
import { errors } from "../plugins/errors";
import Dots from "./ui/DotDotDot";

export default {
    name: "FundingSources",
    props: ["user", "organization", "placesOfService"],
    mixins: [sideMenuItems, errors],
    components: {
        GoLotusSideMenu,
        FundingSourcesSchools,
        FundingSourcesRegionalCenters,
        FundingSourcesEasterseals,
        FundingSourcesInsuranceProviders,
        FundingSourcesPrivatePay,
        FundingSourcesPaid,
        ModalComponent,
        Dots,
    },
    data() {
        return {
            helpers,
            invoices: [],
            patients: [],
            therapists: [],
            pagination: [],
            loading: true,
            component: "funding-sources-schools",
            school: {
                source_type: "school",
                title: "Schools",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Student ID", prop: "authorization_number", align: "left" },
                    { title: "School Name", prop: "source_name", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Service hrs", prop: "service_hours", align: "right" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                ],
            },
            regional_center: {
                source_type: "regional_center",
                title: "Regional Centers",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Authorization #", prop: "authorization_number", align: "left" },
                    { title: "Regional Center", prop: "source_name", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Service hrs", prop: "service_hours", align: "right" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                ],
            },
            easterseal: {
                source_type: "easter_seal",
                title: "Easterseals",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Authorization #", prop: "authorization_number", align: "left" },
                    { title: "Easterseals", prop: "source_name", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Service hrs", prop: "service_hours", align: "right" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                ],
            },
            insurance_provider: {
                source_type: "insurance_provider",
                title: "Insurance Providers",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Status", prop: "last_claim_internal_status", align: "left" },
                    { title: "Therapist", prop: "therapists[0].name", align: "left" },
                    { title: "Insurance Company", prop: "source_name", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                ],
            },
            private_pay: {
                source_type: "private_pay",
                title: "Private Pay",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Service hrs", prop: "service_hours", align: "right" },
                    { title: "Note", prop: "notes", align: "left" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                    { title: "Paid Amount", prop: "paid_amount", align: "right" },
                ],
            },
            paid: {
                title: "Paid",
                fields: [
                    { title: "Service Date", prop: "serviced_at", align: "left" },
                    { title: "Patient", prop: "patient.name", align: "left" },
                    { title: "Therapists", prop: "therapists", align: "left" },
                    { title: "Funding Source", prop: "source_name", align: "left" },
                    { title: "Service hrs", prop: "service_hours", align: "right" },
                    { title: "Clinic Expects", prop: "expected_amount", align: "right" },
                ],
            },
            q: "",
            page: 1,
        };
    },

    watch: {
        organization() {
            this.fetchPatients();
            this.fetchTherapists();
            this.fetchInvoices();
        },
        component() {
            if (this.organization) {
                this.q = "";
                this.fetchInvoices();
            }
        },
        menuItems() {
            let menu = this.menuItems.find(m => m.title === "Funding Sources");
            if (menu) {
                menu.items = [
                    { title: "Schools", component: "funding-sources-schools" },
                    { title: "Regional Centers", component: "funding-sources-regional-centers" },
                    { title: "Easterseals", component: "funding-sources-easterseals" },
                    { title: "Insurance", component: "funding-sources-insurance-providers" },
                    { title: "Private Pay", component: "funding-sources-private-pay" },
                    { title: "Paid", component: "funding-sources-paid" },
                ];
            }
        },
    },

    methods: {
        fetchPage(event) {
            this.page = event;
            this.fetchInvoices(event);
        },

        fetchPatients() {
            axios
                .get(`/api/organizations/${this.organization.id}/patients?with=contracts`)
                .then(r => {
                    this.patients = r.data.data;
                });
        },

        fetchTherapists() {
            axios.get(`/api/organizations/${this.organization.id}/therapists`).then(r => {
                this.therapists = r.data.data;
            });
        },

        fetchInvoices(page) {
            this.loading = true;
            this.invoices = [];
            let queryString = "?with=claim_status&";
            queryString += this.compToProp(this.component, true).source_type
                ? `source_type=${this.compToProp(this.component, true).source_type}`
                : "is_archived=1";
            queryString += this.q ? `&q=${this.q}` : "";
            queryString += page ? `&page=${page}` : "";

            axios
                .get(`/api/organizations/${this.organization.id}/invoices${queryString}`)
                .then(r => {
                    this.invoices = r.data.data;
                    this.pagination = r.data.meta;
                })
                .catch(e => {
                    console.error(e);
                })
                .then(() => {
                    this.loading = false;
                });
        },

        updateInvoice(event) {
            let id = event[0];
            let paid_amount = event[1];
            helpers.toggleSpinner(`action-${id}`);
            axios
                .patch(`/api/organizations/${this.organization.id}/invoices/${id}`, { paid_amount })
                .then(r => {
                    let index = this.invoices.findIndex(invoice => invoice.id === id);
                    this.$set(this.invoices, index, r.data.data);
                    helpers.toggleSpinner(`action-${id}`);
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner(`action-${id}`);
                });
        },

        localUpdateInvoice(event) {
            const index = this.invoices.findIndex(invoice => invoice.id === event.id);
            this.$set(this.invoices, index, event);
            setTimeout(() => {
                if (helpers.isSpinnerActive(`action-${event.id}`)) {
                    helpers.toggleSpinner(`action-${event.id}`);
                }
            }, 100);
        },

        moveInvoicesToPaid(ids) {
            ids.forEach((id, index) => {
                axios
                    .patch(`/api/organizations/${this.organization.id}/invoices/${id}`, {
                        is_archived: 1,
                    })
                    .then(r => {
                        if (index === ids.length - 1) {
                            this.fetchInvoices();
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            });
        },

        moveInvoicesToFunding(ids) {
            ids.forEach((id, index) => {
                axios
                    .patch(`/api/organizations/${this.organization.id}/invoices/${id}`, {
                        is_archived: 0,
                    })
                    .then(r => {
                        if (index === ids.length - 1) {
                            this.fetchInvoices();
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            });
        },

        compToProp(component, asObject) {
            let prop = component.replace("funding-sources-", "").replace("-", "_");
            if (!["funding-sources-private-pay", "funding-sources-paid"].includes(component)) {
                prop = prop.slice(0, -1);
            }
            if (asObject) {
                return this[prop];
            } else {
                return prop;
            }
        },
    },
};
</script>

<style scoped></style>
